import { initialCrudModelBaseState, CrudModelBase } from '@/shared/models/cruds.models'
import {
    BillingGridResponse,
    BillingGridType
} from '@/modules/billing-module/components/grid/config/datasources/billing-grid-datasource-factory'
import { BillingGridDatasource } from '@/modules/billing-module/components/grid/config/datasources/billing-grid.datasource'
import { StrictNullable } from '@/shared/types/app.types'
import { BillingStoreHelper } from '@/modules/billing-module/store/billing-store.helper'
import { BillableDeliveryNoteStatus } from '@/api/services/billing/common-delivery-note/billing-common-delivery-note.dto'
import { InvoiceStatus } from '@/api/services/billing/common-invoice/billing-common-invoice.dto'
import { InvoicePaymentStatus } from '@/api/services/billing/invoice-payment/billing-invoice-payment.dto'
import { InvoiceReceiptStatus } from '@/api/services/billing/invoice-receipt/billing-invoice-receipt.dto'

export type BillingGridState<R = BillingGridResponse> = CrudModelBase<R, BillingGridDatasource<R>>
export const initialBillingGridState =
    (): BillingGridState => initialCrudModelBaseState()

export const getFilterModelDateField =
    (): StrictNullable<string> => {
        switch (BillingStoreHelper.gridType) {
        case BillingGridType.CASES:
            return 'casRequestDate'
        case BillingGridType.CONCEPTS:
            return 'creationDate'
        case BillingGridType.COPAYMENTS:
            return 'creationDate'
        case BillingGridType.DELIVERY_NOTES:
            switch (BillingStoreHelper.category) {
            case BillableDeliveryNoteStatus.GENERATED:
                return 'generationDate'
            case BillableDeliveryNoteStatus.ISSUED:
                return 'issueDate'
            case BillableDeliveryNoteStatus.VERIFIED:
                return 'verificationDate'
            }
            break
        case BillingGridType.INVOICES:
            switch (BillingStoreHelper.category) {
            case InvoiceStatus.GENERATED:
                return 'generationDate'
            case InvoiceStatus.CANCELLED:
                return 'cancellationDate'
            case InvoiceStatus.VERIFIED:
                return 'verificationDate'
            }
            break
        case BillingGridType.INVOICE_PAYMENTS:
            switch (BillingStoreHelper.category) {
            case InvoicePaymentStatus.GENERATED:
                return 'generationDate'
            case InvoicePaymentStatus.CANCELLED:
                return 'cancellationDate'
            case InvoicePaymentStatus.VERIFIED:
                return 'verificationDate'
            }
            break
        case BillingGridType.INVOICE_RECEIPTS:
            switch (BillingStoreHelper.category) {
            case InvoiceReceiptStatus.GENERATED:
                return 'generationDate'
            case InvoiceReceiptStatus.VERIFIED:
                return 'verificationDate'
            }
            break
        }
        return null
    }
